import * as IsActive from '../../components/is_active'

export const FETCH_TRAINING_CONTENT = 'FETCH_TRAINING_CONTENT'
export const INITIALIZE_DATE = 'INITIALIZE_DATE'
export const SELECT_TRAINING_DATE_RANGE = 'SELECT_TRAINING_DATE_RANGE'
export const TRAIN_POST = 'TRAIN_POST'

export const SERVER_RESOURCE = '/posts'

export const TRAINING_MODEL_NAME = 'good-bad-classifier'

export const UNTRAINED_FILTER: IsActive.Filter = {
  description: 'Only show un-trained posts',
  key: 'status',
  value: 'untrained',
}
export const TRAINED_FILTER: IsActive.Filter = {
  description: 'Only show trained posts',
  key: 'status',
  value: 'trained',
}
export const ALL_FILTER: IsActive.Filter = {
  description: 'Show all posts',
  key: 'status',
  value: 'all',
}

export const filterParameters = [UNTRAINED_FILTER, TRAINED_FILTER, ALL_FILTER]

export const CHANGE_DATE_SELECT = 'CHANGE_DATE_SELECT'

export const DATE_SELECT_LAST_NEWSBRIEF_MODE = 'lastNewsbrief'
export const DATE_SELECT_DATE_RANGE_MODE = 'dateRange'

export const SELECT_TRAINING_DATE_RANGE_AND_FILTER = `SELECT_TRAINING_DATE_RANGE_AND_FILTER`

export const DATE_SELECT_LAST_NEWSBRIEF: IsActive.Filter = {
  description: 'Since last newsletter',
  key: 'mode',
  value: DATE_SELECT_LAST_NEWSBRIEF_MODE,
}
export const DATE_SELECT_DATE_RANGE: IsActive.Filter = {
  description: 'Selected date range',
  key: 'mode',
  value: DATE_SELECT_DATE_RANGE_MODE,
}

export const dateSelectFilters = [DATE_SELECT_LAST_NEWSBRIEF, DATE_SELECT_DATE_RANGE]



// WEBPACK FOOTER //
// ./src/pages/training/constants.ts